module.exports = __webpack_public_path__ + "static/logo-200-2ab381216452c2d9f9931467a7c192cc.png";